// extracted by mini-css-extract-plugin
export default {"wrapper":"CreatePropertyInfo_wrapper__f3rzL","col":"CreatePropertyInfo_col__UF9NC"};